import React from 'react';

import './Users.create.phoneList.scss';
import InputPhone from '../../forms/inputs/Input.phone';
import ButtonIcon from '../../forms/buttons/Button.icon';
import Select from '../../forms/inputs/Select';
import {useTranslation} from "react-i18next";
import Checkbox from "../../forms/inputs/Checkboxk";
import AuditTrail from "../../services/interactions/audit.trail";

export default function CreateUserPhoneList({ event, prefix, defaultCountry, error, phones, onChange, required, displaySMSAlerts}) {
    const {t} = useTranslation(['users'])
    const options = [
        { label: t('phone-type.home'), value: 'Home' },
        { label: t('phone-type.mobile'), value: 'Mobile' },
        { label: t('phone-type.work'), value: 'Work' },
        { label: t('other'), value: 'Other' }
    ];

    const _phones = (phones && phones.length ? phones : [{ label: 'Mobile', number: '', code: '', receiveSMS: false, valid: false, required: false}]);

    const handlePhoneChange = (index) => {
        return ({ completeNumber, dialCode, isValid}) => {
            _phones[index].number = completeNumber;
            _phones[index].code = dialCode;
            _phones[index].valid = isValid;
            _phones[index].required = _phones[index].receiveSMS;
            onChange(JSON.parse(JSON.stringify(_phones)));
        }
    }

    const handleLabelChange = (index) => {
        return (label) => {
            _phones[index].label = label;
            if (_phones[index].receiveSMS && _phones[index].label === 'Mobile') {
                _phones[index].receiveSMS = false;
            }
            _phones[index].required = _phones[index].receiveSMS;
            onChange(JSON.parse(JSON.stringify(_phones)));
        }
    }

    const receiveSMSPhoneChange = (index) => {
        return ({ }) => {
            _phones.map((p, i) => {
                if (i !== index) {
                    p.receiveSMS = false;
                    p.required = false;
                }
                return p;
            })
            _phones[index].receiveSMS = !_phones[index].receiveSMS;
            _phones[index].required = _phones[index].receiveSMS;
            onChange(JSON.parse(JSON.stringify(_phones)));
        }
    }
    
    const removePhone = (i) => {
        return () => {
            AuditTrail.sendLog(event, {tag: 'button', event: 'onClick', action: 'button remove phone'});
            _phones.splice(i, 1);
            onChange(JSON.parse(JSON.stringify(_phones)));
        }
    }

    const addNewPhone = () => {
        AuditTrail.sendLog(event, {tag: 'button', event: 'onClick', action: 'button add new phone'});
        _phones.push({ label: 'Mobile', number: '', code: '', receiveSMS: false, valid: false, required: false});
        onChange(JSON.parse(JSON.stringify(_phones)));
    }

    const isRequired = (index) => {
        return (index === 0 && required) || (displaySMSAlerts && _phones[index].receiveSMS);
    }

    return (
        <div className="_phoneRow">
            {
                _phones.map((phone, i) => (
                    <div key={i} className={`_phoneRow phoneBlock ${displaySMSAlerts ? 'three' : 'two'}`}>
                        <div className={`phoneCreate ${error ? 'error' : ''}`}>
                            <InputPhone event={event} defaultCountry={defaultCountry} parentError={error} required={isRequired(i)} id={`${prefix}-phone-${i}`} code={`+${phone.code}`} phone={`${phone.number}`} label="Phone" valid={`${phone.valid}`} onChange={handlePhoneChange(i)} />
                            {
                                i > 0 ?
                                    <ButtonIcon size={30} handleClick={removePhone(i)}>
                                        <span className="material-icons">
                                            delete
                                        </span>
                                    </ButtonIcon>
                                    :
                                    <div></div>
                            }
                        </div>
                        <div>
                            <Select required={i === 0 && required} label="Type" d options={options} value={phone.label} onChange={handleLabelChange(i)} event={event} />
                        </div>
                        {
                           phone.label === 'Mobile' && displaySMSAlerts?
                                <Checkbox label={t('Receive SMS Alerts')} onChange={receiveSMSPhoneChange(i)} bool={phone.receiveSMS} vertical={true} tooltip={'Please make sure that the mobile number for SMS notifications is correct and that there is only one mobile number entered for SMS notifications. Selection of SMS notification as an option indicates that you consent to receive SMS messages and understand that usual data rates could apply.'} event={event} /> : <span/>
                        }
                    </div>
                ))
            }
            <div className="actionButton">
                <ButtonIcon handleClick={addNewPhone} size={34}>
                    <span className="material-icons">
                        add
                        </span>
                </ButtonIcon>
                <p>{t('add-phone')}</p>
            </div>
        </div>)
}
